import React from "react"
import { useNavigate } from "react-router-dom"
import { MessageSquare } from "lucide-react"
import "./styles/About.css"

function About() {
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/contact")
  }

  return (
    <div className="about">
      <h1>Our Company</h1>
      <p className="about-text">
        At Manny&rsquo;s Seamless Gutters, we take pride in being your trusted
        experts in all aspects of gutter services. With years of experience and
        a commitment to excellence, we stand out as a top choice for homeowners
        looking to maintain and protect their properties.
      </p>
      <p className="about-text">
        Our mission is simple: to provide you with the highest quality gutter
        solutions that keep your home safe from water damage. We specialize in
        gutter cleaning, repairs, screening, and maintenance. Whether it&rsquo;s
        preventing clogged gutters, fixing leaky seams, or installing top-grade
        gutter guards, we&apos;ve got you covered.
      </p>
      <p className="about-text">
        What sets us apart is our dedication to customer satisfaction. We treat
        every home as if it were our own, ensuring that your gutters are in
        optimal condition to safeguard your investment. Our team of skilled
        professionals is trained to handle any gutter-related issue promptly and
        efficiently.
      </p>
      <p className="about-text">
        We believe in transparency, integrity, and delivering lasting results.
        When you choose Manny&rsquo;s Seamless Gutters, you&apos;re choosing a
        partner that cares about the well-being of your home. Let us take care
        of your gutter needs so you can enjoy peace of mind knowing your
        property is protected from the elements.
      </p>
      <div className="landing-quote">
        <p className="contactus">Bonded & Insured</p>
        <button className="landing-quote-btn" onClick={handleButtonClick}>
          <MessageSquare />
          Book Online Now!
        </button>
        <p className="contactus">Free Consultations</p>
      </div>
    </div>
  )
}

export default About
